import { CustomTemplatedMessageVariables } from 'generated-graphql/graphql';
import { capitaliseFirstLetter } from 'utils/capitaliseFirstLetter';

const variables = Object.values(CustomTemplatedMessageVariables).map(
  (variable) => ({
    value: variable,
    label: capitaliseFirstLetter(variable.replaceAll('_', ' ').toLowerCase())
  })
);

export const formatTemplatedText = (text: string): string => {
  return variables.reduce((transformedValue, variable) => {
    return transformedValue.replaceAll(
      `{{${variable.value}}}`,
      `{{${variable.label}}}`
    );
  }, text);
};
